import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, ElementRef, ViewChild, NgZone } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { time } from 'console';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { UtilityService } from 'src/app/services/utility.service';
import { UserDocumentService } from '../../services/user-document.service';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { MapsService } from 'src/app/services/maps.service';
import { AssetService } from 'src/app/services/asset.service';
@Component({
  selector: 'app-environmental-incident-reporting-form',
  templateUrl: './environmental-incident-reporting-form.component.html',
  styleUrls: ['./environmental-incident-reporting-form.component.scss']
})
export class EnvironmentalIncidentReportingFormComponent implements OnInit {

  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;
  @Input('accident') accidentData
  @Input('user') userData
  @Input('documentData') documentDetails
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  previousIndex: any;
  environmentalForm: FormGroup;
  environmentalForm2: FormGroup;
  minTime
  sign: boolean;
  date: any;
  loading: boolean;
  isSubmit: boolean;
  isDate: boolean;
  isDateSubmit: boolean;
  chosenTime
  accidentId: any;
  userId: any;
  accidentDetails: any;
  userDetails: any;
  formDetails: any;
  form2Details: any;
  extraDetails: any;
  isEdit: boolean;
  userName: any;
  currentUser
  accidentLocation: any;
  dateOfIncident: any;
  files: any = [];
  newFiles: any = []
  user: any;
  isAdmin: boolean;
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  isMapEdit: boolean
  constructor(
    public dialog: MatDialog,
    public router: Router,
    private _mapsService: MapsService,
    private formBuilder: FormBuilder,
    public _utilityService: UtilityService,
    public _assetService: AssetService,
    public _userDocumentService: UserDocumentService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'));
    console.log("this.user", this.user);
    if (this.user.isAdmin) {
      console.log("this.isAdmin", this.user.isAdmin);
      this.isAdmin = true
    }

    if (this.isEdit) { }
    else {
      // this.setCurrentLocation();
    }
    this.createForm1()
    this.createform2()
    this.isSubmit = false;
    this.isDateSubmit = false
  }



  ngOnChanges(changes: SimpleChanges): void {
    console.log("Environment changes", changes);
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))

    if (changes.accidentData && changes.accidentData.currentValue) {
      this.accidentId = changes.accidentData.currentValue
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
    }
    if (changes.documentDetails && changes.documentDetails.currentValue) {
      let data = changes.documentDetails.currentValue
      this.accidentDetails = data.accidentDetails
      this.userDetails = data.userData

      if (data && data.details && (data.details.details.environmentalForm || data.details.details.environmentalForm2)) {
        this.formDetails = data.details.details.environmentalForm
        this.form2Details = data.details.details.environmentalForm2
        this.extraDetails = data.details
        this.files = data.details.files
        this.chosenTime = this.formDetails.time
        this.date = this.formDetails.date
        this.isEdit = true
        this.isMapEdit = true
        if (this.formDetails && this.formDetails.sign != "") {
          this.sign = true
        }

        let locationData = data.details.details.environmentalForm


        this.latitude = (locationData && locationData.location) ? locationData.location.coords.lat : ''
        console.log("here is the latitude", this.latitude)
        this.longitude = (locationData && locationData.location) ? locationData.location.coords.lng : ''
        this.address = (locationData && locationData.location) ? locationData.location.address : ''


        // this.latitude = data.details.details.environmentalForm.location.coords.lat
        // console.log("here is the latitude", this.latitude)
        // this.longitude = data.details.details.environmentalForm.location.coords.lng
        // this.address = data.details.details.environmentalForm.location.address
        this.environmentalForm.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }
        this.createForm1(this.formDetails)
        this.createform2(this.form2Details)
      } else {



        this.isEdit = false
        this.isMapEdit = false
        if (this.userDetails && this.userDetails._id && this.userDetails._id.user) {
          console.log("this user details", this.userDetails);

          this.userName = this.userDetails._id.user.name
        } else {
          this.userName = this.userDetails.user.name
        }
        this.accidentLocation = this.accidentDetails.location.address
        this.dateOfIncident = this.accidentDetails.date
        this.createForm1()
        this.createform2()
        console.log("call this else part", this.userName, this.accidentLocation);
      }
    }


  }


  // FORM GROUP

  createForm1(data?) {
    this.environmentalForm = this.formBuilder.group({
      date: new FormControl((data && data.date) ? data.date : '', Validators.required),
      time: new FormControl((data && data.time) ? data.time : ''),
      // location: new FormControl((data && data.location) ? data.location : this.accidentLocation),
      details: new FormControl((data && data.details) ? data.details : ''),
      reason: new FormControl((data && data.reason) ? data.reason : ''),
      action: new FormControl((data && data.action) ? data.action : ''),
      name: new FormControl((data && data.name) ? data.name : this.userName),
      sign: new FormControl((data && data.sign) ? data.sign : '', Validators.required),
      distribution: new FormControl((data && data.distribution) ? data.distribution : '')
    })
  }

  createform2(data?) {
    this.environmentalForm2 = this.formBuilder.group({
      nearWatercourse: new FormControl((data && data.nearWatercourse) ? data.nearWatercourse : ''),
      enteredWatercourse: new FormControl((data && data.enteredWatercourse) ? data.enteredWatercourse : ''),
      agencyInvolved: new FormControl((data && data.agencyInvolved) ? data.agencyInvolved : ''),
      authorityInvolved: new FormControl((data && data.authorityInvolved) ? data.authorityInvolved : ''),
      servicesInvolved: new FormControl((data && data.servicesInvolved) ? data.servicesInvolved : ''),
      ifYesWhich: new FormControl((data && data.ifYesWhich) ? data.ifYesWhich : ''),
      actionRequired: new FormControl((data && data.actionRequired) ? data.actionRequired : ''),
      ifYesDetails: new FormControl((data && data.ifYesDetails) ? data.ifYesDetails : ''),
      prevented: new FormControl((data && data.prevented) ? data.prevented : ''),
    })
  }


  // UTILITY

  //   private setCurrentLocation() {
  //     // this._mapsService.setCurrentLocation().subscribe((data) => {
  //     //   console.log("data------->", data);
  //     //   this.latitude = data.latitude;
  //     //   this.longitude = data.longitude;
  //     // })
  //     this._mapsService.setCurrentLocation().subscribe((data) => {
  //       this.latitude = data.latitude;
  //       this.longitude = data.longitude;
  //       this.address = data.address
  //       let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);

  //       autocomplete.addListener("place_changed", () => {

  //         this.ngZone.run(() => {

  //           let place: google.maps.places.PlaceResult = autocomplete.getPlace();


  //           if (place.geometry === undefined || place.geometry === null) {
  //             return;
  //           }
  //           console.log("not returned ------------------")
  //           console.log('PLACE------------->', place)
  //           this.latitude = place.geometry.location.lat();
  //           console.log("this.latitude",this.latitude)
  //           this.longitude = place.geometry.location.lng();
  //           console.log("this.longitude", this.longitude)
  //           this.address = place.formatted_address
  //           this.zoom = 12;

  //         });

  //       });
  //   });
  // }
  // markerDragEnd(event) {
  //   console.log('mark drag event check', event);
  //   this._mapsService.markerDragEnd(event).subscribe((data) => {
  //     console.log("data------->", data);
  //     this.latitude = data.latitude;
  //     this.longitude = data.longitude;
  //     this.address = data.address;
  //   });
  // }

  setCurrentLocation(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address
  }



  onChangeEvent(value) {
    this.environmentalForm.patchValue({ date: value })
    console.log(this.date);
    this.isDate = true;
    this.isDateSubmit = false
  }

  timeChanged(value) {
    console.log("clock time", value);
    this.environmentalForm.patchValue({
      time: value
    })
  }

  addSignature(fomrControl) {
    const dialogRef = this._utilityService.commonDialogBoxOpen(SignaturePadComponent,
      null, '100%', '100%', '100vw', '100vh').afterClosed().subscribe((data) => {
        console.log("data of sign", data);
        this.sign = true
        this.isSubmit = false
        if (fomrControl == 'sign') {
          this.environmentalForm.patchValue({
            sign: data
          })
          console.log("sign value", this.environmentalForm.value);
        }
      })
  }

  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue == undefined || fileQueue.length == 0) return;

        _.forEach(fileQueue, (file) => {
          if (this.isEdit) {
            this.newFiles.push(file)
          } else {
            this.files.push(file);
          }
        })
        this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })
      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }


  deleteFile(event, index) {
    console.log("event if file removed", event, this.isEdit);
    this.files.splice(index, 1)
    console.log("after file removd", this.files);

  }
  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
  }

  // API CALL

  onSubmit() {
    let param = {
    }
    if (this.environmentalForm.valid && this.environmentalForm2.valid) {
      this.loading = true;
      console.log("form value-1", this.environmentalForm.value)
      console.log("form value-2", this.environmentalForm2.value)
      // this.loading = false;
      if (this.isEdit) {

        console.log("this is for edit form");


        let obj = {
          metaObj: {
            title: 'envForm',
          },
          documentId: this.accidentId,
          userId: this.userId,
          onModel: 'accident',
          documentMetaId: this.extraDetails.documentMetaId,
          userDocumentId: this.extraDetails._id,
          files: this.files,
          newFiles: this.newFiles,
          details: {}
        }

        this.environmentalForm.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }

        let details = {
          environmentalForm: this.environmentalForm.value,
          environmentalForm2: this.environmentalForm2.value
        }
        obj['details'] = details

        this._userDocumentService.updateUserDocument(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this.loading = false
          this._utilityService.handleSnackBar({ msg: "Data updated successfully!", button: "OK" })
          this.redirect()
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
          this.loading = false
        })


      } else {
        let obj = {
          metaObj: {
            title: 'envForm',
          },
          documentId: this.accidentId,
          userId: this.userId,
          onModel: 'accident',
          files: this.files,
          // documentId: this.planFormDetails._id,
          details: {}
        }

        this.environmentalForm.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }

        let details = {
          environmentalForm: this.environmentalForm.value,
          environmentalForm2: this.environmentalForm2.value
        }
        obj['details'] = details

        this._userDocumentService.addUserDocument(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this.loading = false
          this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
          this.redirect()
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
          this.loading = false
        })
      }
      // this._utilityService.handleSnackBar({ msg: "Environmental Incident Reporting Form Submision Successfully!", button: "OK" })
    }
    else {
      this.loading = false;
      this.isSubmit = true
      this.isDateSubmit = true
      this.environmentalForm.markAllAsTouched()
      this.environmentalForm2.markAllAsTouched()
    }

  }

  redirect() {
    this._assetService.closeDisplayFile(true)
    let param = {
    }
    param['accidentId'] = this.accidentId
    if (this.isAdmin) {
      this.router.navigate(['/accident/single-accident'], { queryParams: param })
    }
    else {
      this.router.navigate(['/accident'])
    }
  }


}
